module.exports = __webpack_public_path__ + "static/media/download-icon.cd11ffc1.svg";